import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  borderColor: (p) => p.palette.grey[300],
  background: (p) => p.palette.grey[100],
  padding: (p) => p.spacing(1.5, 2),
  gap: (p) => p.spacing(1.5),
  position: 'sticky',
  top: 0,
  zIndex: 10,
};

export const card: SxStyle = {
  borderColor: (p) => p.palette.primary[200],
};

export const cardContent: SxStyle = {
  '&.MuiCardContent-root:last-child': { paddingBottom: 1.5 },
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[100],
  backgroundColor: (p) => p.palette.primary[300],
  borderRadius: '50%',
  cursor: 'pointer',
};

export const modalBox: SxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 960,
  backgroundColor: 'background.paper',
  boxShadow: 24,
};

export const modalIframe: SxStyle = {
  display: 'block',
  width: '100%',
  aspectRatio: '16 / 9',
  border: 'none',
  borderRadius: (p) => p.spacing(0.5),
};
